// Generates a secure UUID user token
export const createUserToken = () => {
  const number = [1e7] + -1e3 + -4e3 + -8e3 + -1e11;
  const pattern = /[018]/g;

  const getRandomValue = () => {
    const array = new Uint8Array(1);
    crypto.getRandomValues(array);
    return array[0];
  }

  const replaceChar = (char) => {
    const randomValue = getRandomValue();
    return (char ^ randomValue & 15 >> char / 4).toString(16);
  }

  const token = number.toString().replace(pattern, replaceChar);
  return token;
};
